
























































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { isUserAllowed } from '@/utils/rbac.util';
import { PermissionsMatrixActionsEnum } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { RootState } from '@/store/store';
import { ApplicationContext } from '@/store/modules/application-context/types/application-context.types';
import { NavLink } from '@/jbi-shared/types/Nav';
import { get as _get } from 'lodash';

interface NavImage {
  src: any;
  width: string;
  height: string;
  alt: string;
}

interface NavbarLink {
  class: string[];
  to: string | { path: string; query: Record<string, string> };
  moduleName: string;
  isUserAllowed: boolean;
  label: string;
}

@Component({
  components: {}
})
export default class Navbar extends Vue {
  @Prop(String) public userName!: string;
  @Prop(String) public userEmail!: string;
  @Prop({ type: Array, required: true })
  public navLinks!: NavLink[];

  @Getter('rbac/isAdmin')
  public isAdmin!: boolean;

  @Getter('userAttribute/isMissingAttributeValue')
  public isMissingAttributeValue!: boolean;

  @State(({ auth }: RootState) => auth.isLoggedIn)
  isLoggedIn!: boolean;

  @State(
    ({ applicationContext }: RootState) => applicationContext.applicationContext
  )
  private applicationContext!: ApplicationContext;

  private myJBILogo = require('../jbi-shared/assets/images/myjbi_modal_img.png');
  private jtmsLogo = require('../jbi-shared/assets/images/jtms-logo.png');

  private navItemClass = this.isMissingAttributeValue
    ? 'navItemDisabled'
    : 'navItem';
  private myJBINavbarLinks: NavbarLink[] = [];
  private myJBIBaseNavbarLink: NavbarLink | null = null;
  private jtmsNavbarLinks: NavbarLink[] = [];
  private jtmsBaseNavbarLink: NavbarLink | null = null;

  private isSidebarOpen: boolean = false;

  private toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  private closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  get logoBasedOnContext(): NavImage {
    switch (this.applicationContext) {
      case ApplicationContext.JTMS:
        return {
          src: this.jtmsLogo,
          width: '100%',
          height: '30px',
          alt: 'JTMS Logo'
        };
      case ApplicationContext.JAAS:
        return {
          src: this.myJBILogo,
          width: '68.57px',
          height: '30px',
          alt: 'MyJBI Logo'
        };
      default:
        return {
          src: this.myJBILogo,
          width: '68.57px',
          height: '30px',
          alt: 'MyJBI Logo'
        };
    }
  }

  get navLinksBasedOnContext(): NavbarLink[] {
    switch (this.applicationContext) {
      case ApplicationContext.JTMS:
        return this.jtmsNavbarLinks;
      case ApplicationContext.JAAS:
        return this.myJBINavbarLinks;
      default:
        return this.myJBINavbarLinks;
    }
  }

  get baseNavLinksBasedOnContext(): NavbarLink {
    switch (this.applicationContext) {
      case ApplicationContext.JTMS:
        return this.jtmsBaseNavbarLink!;
      case ApplicationContext.JAAS:
        return this.myJBIBaseNavbarLink!;
      default:
        return this.myJBIBaseNavbarLink!;
    }
  }

  created(): void {
    /**
     * Navigation link variables are being initialised inside created()
     * lifecycle method to be able to use this.$route. $route is not ready
     * during component creation.
     */
    this.myJBINavbarLinks = [
      {
        class: ['navbar-item', this.navItemClass],
        to: '/products',
        moduleName: 'products',
        isUserAllowed: isUserAllowed(
          PermissionsMatrixActionsEnum.READ,
          'products'
        ),
        label: 'products'
      },
      {
        class: ['navbar-item', this.navItemClass],
        to: '/orders',
        moduleName: 'my_orders',
        isUserAllowed: isUserAllowed(
          PermissionsMatrixActionsEnum.READ,
          'my_orders'
        ),
        label: 'my orders'
      },
      {
        class: [
          'navbar-item',
          this.navItemClass,
          this.$route.path === '/account' ? 'isNavActive' : ''
        ],
        to: { path: '/account', query: { tab: 'profile' } },
        moduleName: 'account',
        isUserAllowed: isUserAllowed(
          PermissionsMatrixActionsEnum.READ,
          'account'
        ),
        label: 'account'
      }
    ];

    this.jtmsNavbarLinks = [
      {
        class: ['navbar-item', this.navItemClass],
        to: '/admin/jtms/dashboard',
        moduleName: 'jtms_dashboard',
        isUserAllowed: true,
        label: 'dashboard'
      },
      {
        class: ['navbar-item', this.navItemClass],
        to: '/admin/jtms/payments',
        moduleName: 'jtms_payments',
        isUserAllowed: true,
        label: 'payments'
      },
      {
        class: ['navbar-item', this.navItemClass],
        to: '/admin/jtms/discounts',
        moduleName: 'jtms_discounts',
        isUserAllowed: true,
        label: 'discounts'
      }
    ];

    /**
     * Separately maintain the base/default link of the respective applications.
     */
    this.myJBIBaseNavbarLink = {
      class: ['navbar-item', this.navItemClass],
      to: '/',
      moduleName: 'non_module',
      isUserAllowed: true,
      label: 'landing page'
    };

    this.jtmsBaseNavbarLink = this.jtmsNavbarLinks[0];
  }
}
